<template>
	<div class="add-to-cart-widget">
		<div class="buttons-wrapper" :class="{ invalid: !isValid }">
			<count-button
				v-if="isValid"
				:items-count="productsCount"
				:is-add-button-disabled="isAddProductDisabled"
				:max-count="maxProductsCount"
				@decrease="removeItem"
				@increase="addItem"
			/>
			<primary-button
				large
				:loading="isLoading"
				:disabled="isAddProductButtonDisabled"
				@click="addToCart"
			>
				{{ mainButtonText }}
				&nbsp;
				<formatted-price :price="productsAmount" decimal-height="70" />
			</primary-button>
		</div>
	</div>
</template>

<script>
import CountButton from '@/components/CountButton'
import PrimaryButton from '@/components/Buttons/PrimaryButton.vue'
import FormattedPrice from '@/components/FormattedPrice.vue'

export default {
	name: 'AddToCart',

	components: {
		FormattedPrice,
		PrimaryButton,
		CountButton
	},

	props: {
		productsCount: {
			type: Number,
			default: 0
		},
		maxProductsCount: {
			type: Number,
			default: 999
		},
		productsAmount: {
			type: Number,
			default: null
		},
		productInCartCount: {
			type: Number,
			default: 0
		},
		isEditing: {
			type: Boolean,
			default: false
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		isOrderProductEditing: {
			type: Boolean,
			default: false
		},

		isValid: {
			type: Boolean,
			default: true
		}
	},

	computed: {
		mainButtonText() {
			if (this.isValid) {
				return this.isEditing || this.isOrderProductEditing
					? 'Update cart'
					: 'Add to Cart'
			} else {
				return 'Make required selection'
			}
		},
		isAddProductDisabled() {
			return (
				this.productsCount + this.productInCartCount >= this.maxProductsCount
			)
		},

		isAddProductButtonDisabled() {
			return (
				this.isLoading ||
				this.productsCount + this.productInCartCount > this.maxProductsCount
			)
		}
	},

	methods: {
		addToCart() {
			this.$emit('add-to-cart')
		},

		addItem() {
			this.$emit('change-products-count', this.productsCount + 1)
		},

		removeItem() {
			this.$emit('change-products-count', this.productsCount - 1)
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.add-to-cart-widget {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 16px 10px;
	background: $background-popup;
	box-shadow: 0px 0px 11px 8px rgba($black, 0.5);
	z-index: 21;

	@media (min-width: 640px) {
		padding: 16px;
	}

	.buttons-wrapper {
		display: flex;
		align-items: center;

		@media (min-width: 640px) {
			justify-content: space-between;
			gap: 16px;
		}

		&.invalid {
			justify-content: flex-end;

			.primary-button {
				width: 100%;
				max-width: 100%;
			}
		}
	}

	.primary-button {
		flex-grow: 1;
		padding: 10px 20px;
		height: 45px;
		font-size: 16px;
		transition: background-color 0.3s;
		letter-spacing: initial;

		&:hover {
			background-color: $light-purple;
		}

		@media (min-width: 640px) {
			min-width: 132px;
			width: 373px;
			max-width: 373px;
			white-space: nowrap;
			flex-grow: 1;
			flex-shrink: 0;
			padding: 18px 50px;
			height: 56px;
			font-size: 16px;
		}

		/deep/ .content {
			justify-content: space-between;
		}
	}

	.count-button {
		height: 45px;
		margin-right: 8px;
		width: 120px;
		font-size: 16px;

		@media (min-width: 640px) {
			width: auto;
			max-width: 124px;
			margin-right: 16px;
			flex-grow: 1;
			height: 56px;
		}
	}
}
</style>
